import { useTranslation } from "react-i18next";
import DataTable from "../../components/carbon/DataTable/DataTable";
import EmptyState from "../../components/carbon/EmptyState/EmptyState";
import { OfferResponse, OrderState, SupplierRfqActivity } from "../../types";
import { useUser } from "../../context";
import {
  buildMultipleOfferRows,
  multipleOfferListHeaders,
} from "./multipleOfferRows";
import "./bid.scss";

type OffersOnMultipleOrdersProps = {
  offOnOrd?: OfferResponse[][];
  handleItemClick: (offers: OfferResponse[]) => void;
  state?: OrderState;
  /** Whose validation the table shows, matched to the rows by email. */
  activity?: SupplierRfqActivity[];
};

/**
 * The buyer's offers table for a JOINT order (Task 7) — same Carbon `DataTable` rebuild as
 * `OffersOnOrders.tsx`, one row per seller (`offers[]` carries that seller's offer for every
 * material line — see `multipleOfferRows.tsx` for why only the first line's price/comment ever
 * rendered, faithfully preserved).
 */
const OffersOnMultipleOrders = ({
  offOnOrd,
  handleItemClick,
  state,
  activity,
}: OffersOnMultipleOrdersProps) => {
  const { isCompliant } = useUser();
  const { t } = useTranslation();

  const hideOfferDetails = state === OrderState.OPEN && isCompliant;

  const rows = buildMultipleOfferRows(offOnOrd, hideOfferDetails, t, activity);
  const headers = multipleOfferListHeaders(t);

  return (
    <div className="bid-offers-table">
      <DataTable
        headers={headers}
        rows={rows}
        isLoading={false}
        onRowClick={(row) => handleItemClick(row.offers)}
        empty={<EmptyState title={`${t("tenders.data.noOffers")}.`} />}
      />
      {hideOfferDetails && rows.length > 0 && (
        <p className="bid-offers-table__notice">
          {t("tenders.data.visualize")}
        </p>
      )}
    </div>
  );
};

export default OffersOnMultipleOrders;
